import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-786342ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "disabled"]

import { PropType } from 'vue';

type ButtonType = 'button' | 'submit' | 'reset';
type ButtonTheme = 'primary' | 'secondary' | 'text' | 'tertiary';
type ButtonSize = 's' | 'm';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  type: {
    type: String as PropType<ButtonType>,
    default: 'button',
  },
  theme: {
    type: String as PropType<ButtonTheme>,
    default: 'primary',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<ButtonSize>,
    default: 'm',
  },
},
  emits: {
  click: () => true,
},
  setup(__props, { emit }) {

const props = __props




const handleClick = () => {
  emit('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(`button_${props.theme} size-${props.size}`),
    type: props.type,
    disabled: props.disabled,
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})